document.addEventListener('DOMContentLoaded', () => {
  const sortItems   = document.querySelectorAll('[js-sort-item]');
  const sortDetails = document.querySelector('[js-sort-details]');
  const sortSummary = sortDetails.querySelector('[js-sort-select]');

  const parseDate = (str) => {
    const [day, month, year] = str.split('/');
    return new Date(`${year}-${month}-${day}`);
  };

  const sortGrid = (grid, order) => {
    const lastCard = grid.querySelector('[js-last-card]');
    const items = Array.from(grid.querySelectorAll('[js-album-item]'));
    
    items.sort((a, b) => {
      const da = parseDate(a.dataset.date);
      const db = parseDate(b.dataset.date);
      return order === 'ascending' ? da - db : db - da;
    });

    items.forEach(item =>
      lastCard ? grid.insertBefore(item, lastCard) : grid.appendChild(item)
    );
  };

  sortItems.forEach(btn => {
    btn.addEventListener('click', () => {
      const order   = btn.dataset.sort; 
      const grids   = document.querySelectorAll('[js-albums-grid],[js-collabs-grid]');

      grids.forEach(grid => sortGrid(grid, order));

      if (sortSummary) {
        sortSummary.textContent = order === 'ascending'
          ? 'Oldest‑Newest'
          : 'Newest‑Oldest';
      }

      sortDetails.removeAttribute("open")
    });
  });

  document.addEventListener("click", function({ target }) {
    if(!target.hasAttribute("[js-sort-details]")) {
      sortDetails.removeAttribute("open")
    }
  })
});